import PropTypes from "prop-types";
import { graphql } from "gatsby";
import Layout from "@layout";
import SEO from "@components/seo";
import PageBreadcrumb from "../../components/pagebreadcrumb";
import PhotosDataInit from "../../components/photosdata/rally-on-1st-insurance-day.json";
import Data from "../../components/photosdata/Data";
import { normalizedData } from "@utils/functions";
import { Container } from "react-bootstrap";
import axios from "axios";
import { useEffect, useState } from "react";
import Preload from "../../components/preloadPage/preload";
const RallyOn1stInsuranceDay = ({ data, location, pageContext }) => {
    const [PhotosData, setJsonData] = useState(PhotosDataInit);
    const [preload, setPreload] = useState(true);
    useEffect(() => {
        axios(
            "https://admin.reliance.com.bd/api/sendJSON/62a75228d69abc065dad2dde"
        )
            .then((resultData) => {
                setJsonData(resultData.data);
                setPreload(false);
            })
            .catch((err) => {
                console.log(err);
                setPreload(false);
            });
    }, []);
    const globalContent = normalizedData(data?.allGeneral?.nodes || []);
    return (
        <Layout
            data={{
                ...globalContent["menu"],
                ...globalContent["footer"],
            }}
        >
            {" "}
            {preload && <Preload />}
            <SEO title="Rally On 1st Insurance Day" pathname="/" />
            <PageBreadcrumb
                pageContext={pageContext}
                location={location}
                title="Rally On 1st Insurance Day"
            />
            <Container>
                <div className="row">
                    <Data data={PhotosData} />
                </div>
            </Container>
        </Layout>
    );
};
RallyOn1stInsuranceDay.propTypes = {
    location: PropTypes.object,
    pageContext: PropTypes.object,
    data: PropTypes.shape({
        allGeneral: PropTypes.shape({
            nodes: PropTypes.arrayOf(PropTypes.shape({})),
        }),
        allArticle: PropTypes.shape({
            nodes: PropTypes.arrayOf(PropTypes.shape({})),
        }),
    }),
};

export const query = graphql`
    query RallyOn1stInsuranceDayQuery {
        allGeneral {
            nodes {
                section
                id
                menu {
                    ...Menu
                }
                footer {
                    ...Footer
                }
            }
        }
        allArticle {
            nodes {
                ...Articles
            }
        }
    }
`;

export default RallyOn1stInsuranceDay;
